import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useActiveService } from 'hooks/useActiveService';
import { ThemeProvider as MUIThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { getTheme } from '@totalsoft/rocket-ui';
import { APPLICATION_THEME_QUERY } from 'features/branding/queries';
import { camelize } from 'utils/functions';
import { useQuery } from 'hooks/apollo';
const { REACT_APP_DEFAULT_THEME } = process.env;

const ThemeProvider = ({ children }) => {
  const { activeServiceLoaded } = useActiveService();
  const { data } = useQuery(APPLICATION_THEME_QUERY, {
    skip: !activeServiceLoaded,
    onError: err => console.warn(`Application theme could not be loaded! ${err}`)
  });

  const theme = useMemo(() => camelize(data?.applicationTheme?.themeName || REACT_APP_DEFAULT_THEME), [data]);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={getTheme({ globals: { theme } })}>{children}</MUIThemeProvider>
    </StyledEngineProvider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node
};

export default ThemeProvider;
